import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { toaster } from "../../../utils/utils";
import greenTick from "../../../Assets/images/green_check.svg";
import { cisRegenerate } from "../../../store/actions/cisRegenerate";

const CIS = () => {
  const [proposalNumber, setProposalNumber] = useState("");
  const [file, setFile] = useState();
  const [fileName, setFileName] = useState("");

  const dispatch = useDispatch();

  const triggerUploadCSV = () => {
    document.getElementById("pdf-upload").click();
  };

  const uploadFile = (uploadedFile) => {
    setFileName(uploadedFile.name);
    const formData = new FormData();
    formData.append("file", uploadedFile);
    setFile(formData);
  };

  const regenerateCISdoc = () => {
    if (!proposalNumber || !file) return;
    dispatch(
      cisRegenerate(proposalNumber, file, (data) => {
        const blob = new Blob([data], { type: "application/pdf" });
        const blobUrl = URL.createObjectURL(blob);
        const newTab = window.open(blobUrl);

        setTimeout(() => {
          const link = document.createElement("a");
          link.href = blobUrl;
          link.download = `new${fileName}`;
          newTab.document.body.appendChild(link);
          link.click();
          newTab.document.body.removeChild(link);
          URL.revokeObjectURL(blobUrl);
        }, 1000);
      })
    );
  };

  return (
    <div className="operations-page__panel">
      <div className="operations-page__controls-row">
        <div className="operations-page__field operations-page__field--grow">
          <label className="operations-page__label" htmlFor="cis-proposal">
            Proposal number
          </label>
          <input
            id="cis-proposal"
            name="proposalNumber"
            value={proposalNumber}
            onChange={(e) => setProposalNumber(e.target.value)}
            className="operations-page__input"
            type="text"
            placeholder="Enter proposal number"
          />
        </div>
        <button
          type="button"
          className="operations-page__btn operations-page__btn--secondary"
          onClick={triggerUploadCSV}
        >
          Upload file
        </button>
        <input
          id="pdf-upload"
          className="operations-page__file-input"
          type="file"
          name="file"
          accept="application/pdf"
          onChange={(e) => {
            if (
              e.target.files &&
              e.target.files.length &&
              e.target.files[0].size / 1000 / 1000 > 10
            ) {
              return toaster(
                "warn",
                "Selected file size cannot be greater than 10 mb."
              );
            } else if (e.target.files && e.target.files.length) {
              uploadFile(e.target.files[0]);
            }
          }}
          onClick={(e) => {
            e.target.value = null;
          }}
        />
        {fileName && (
          <div className="operations-page__file-name">
            <span>{fileName}</span>
            <img
              src={greenTick}
              alt="Uploaded"
              className="operations-page__file-tick"
            />
          </div>
        )}
      </div>
      <div className="operations-page__actions">
        <button
          type="button"
          className={`operations-page__btn operations-page__btn--primary ${
            proposalNumber && file ? "" : "operations-page__btn--disabled"
          }`}
          onClick={regenerateCISdoc}
          disabled={!proposalNumber || !file}
        >
          Submit
        </button>
      </div>
    </div>
  );
};

export default CIS;
